// extracted by mini-css-extract-plugin
export var header = "_tx-1";
export var maskBottom = "_tx-6";
export var maskMiddle = "_tx-7";
export var maskTop = "_tx-5";
export var root = "_tx-0";
export var scrollDownButton = "_tx-3";
export var scrollDownButtonHidden = "_tx-4";
export var viewport = "_tx-2";